import React from 'react';
import { useNavigate } from 'react-router-dom';

const Blogs = () => {
    const navigation = useNavigate();
    return (
        <div className='h-screen  mx-12'>
             <button
        onClick={() => navigation('/')}
        className=" mt-5 btn btn-primary text-white"
      >
        ← Back to Home
      </button>
            <div className='h-screen flex justify-center items-center'>
            <h2>
                COMING SOON!
            </h2>
           </div>
        </div>
    );
};

export default Blogs;